import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { handleUserForgotPassword } from "../../shared/controllers/authController";

import authbg from "./assets/authbg.svg";
import load from "./assets/load.gif";
import logo from "./assets/logo.svg";

interface FormErrors {
    email?: string;
}

const PasswordReset: React.FC = () => {
    const [email, setEmail] = useState<string>("");
    const { enqueueSnackbar } = useSnackbar();
    const [errors, setErrors] = useState<FormErrors>({});
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const validateFields = (): boolean => {
        const newErrors: FormErrors = {};
        if (!email) newErrors.email = "Email is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const onSuccess = () => {
        setLoading(false);
        // Save the email to localStorage
        localStorage.setItem("resetEmail", email);
        // Navigate to the new password page
        navigate("/new-password");
        enqueueSnackbar("Mail sent", { variant: "success" });
    };

    const onError = () => {
        setLoading(false);
        enqueueSnackbar("Something went wrong, please try again.", {
            variant: "error",
        });
    };

    const handleSubmit = () => {
        if (validateFields()) {
            // If validation passes, proceed with creating the account
            setLoading(true);
            const userData = {
                email,
            };
            handleUserForgotPassword(userData, onSuccess, onError);
        }
    };

    return (
        <>
            <div
                style={{
                    backgroundImage: `url(${authbg})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
                className="w-full md:w-[120%] h-full bg-[#1212128d] z-[999] fixed top-0 left-0 md:-left-[20%] p-6 flex justify-center items-center"
            >
                <div className="md:ml-[20%] h-[550px] bg-[#FFFFFF] p-6 rounded-[15px] w-full md:w-[550px]">
                    <div className="w-full h-full bg-[#fff] overflow-y-auto p-4 md:p-4 flex flex-col items-center">
                        <img src={logo} className=" w-[20%]" alt="" />
                        <p className=" mt-6 text-center font-Manrope font-bold text-[#272D37] text-3xl">
                            Reset Password
                        </p>
                        <p className=" text-center font-Manrope  text-xl font-medium text-[#272D37] mt-3">
                            Enter your email address below to reset your password
                        </p>
                        <label
                            htmlFor=""
                            className=" flex flex-col w-full font-Manrope font-semibold text-sm text-[#272D37] mt-6"
                        >
                            Email
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className=" mt-2 border border-[#DAE0E6] px-4 py-3 rounded-md font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                                placeholder="Enter your Email"
                            />
                            {errors.email && (
                                <span className="text-red-500 text-xs font-Manrope mt-2">
                                    {errors.email}
                                </span>
                            )}
                        </label>

                        <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className=" bg-[#317333] rounded-md w-full mt-6 py-3 font-Manrope text-[#fff] font-semibold text-base flex justify-center  items-center"
                        >
                            {loading ? (
                                <img src={load} className=" w-5" alt="Loading" />
                            ) : (
                                "Reset Password"
                            )}
                        </button>
                        <p className=" mt-2 font-normal text-sm font-Manrope text-[#5F6D7E]">
                            Back to sign in page?{" "}
                            <Link
                                to="/sign-in"
                                className=" font-Manrope text-[#317333] font-bold text-[15px]"
                            >
                                Sign in
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PasswordReset;
